export * from './openAuthorizationPage';
